"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _FullScreenView = _interopRequireDefault(require("../../../../Screens/Configurator/Components/FullScreenView"));
var _styles = require("@material-ui/core/styles");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var styles = function styles(theme) {
  var _thumbnailGrid;
  return {
    viewsContainer: _defineProperty({}, theme.orientation.landscape, {
      height: 136
    }),
    thumbnailGrid: (_thumbnailGrid = {
      bottom: -16
    }, _defineProperty(_thumbnailGrid, theme.breakpoints.up('sm'), {
      minHeight: 136
    }), _defineProperty(_thumbnailGrid, theme.breakpoints.up('md'), _defineProperty({
      bottom: 0
    }, theme.orientation.portrait, {
      width: '25%'
    })), _defineProperty(_thumbnailGrid, theme.orientation.landscape, {
      height: 136
    }), _defineProperty(_thumbnailGrid, '@media (min-aspect-ratio: 13/9) and (min-height: 280px) and (max-width: 950px)', {
      width: '100%',
      maxWidth: '100%',
      position: 'absolute',
      bottom: 0,
      height: 60,
      minHeight: 60
    }), _thumbnailGrid),
    button: _defineProperty({}, theme.orientation.landscape, _defineProperty({}, theme.breakpoints.down('sm'), {
      left: '50%'
    })),
    buttonTop: _defineProperty({}, theme.breakpoints.up('sm'), {
      display: 'none'
    }),
    buttonBottom: _defineProperty({}, theme.breakpoints.down('xs'), {
      display: 'none'
    })
  };
};
var DesignerFullScreenView = function DesignerFullScreenView(props) {
  return /*#__PURE__*/_react["default"].createElement(_FullScreenView["default"], props);
};
var _default = exports["default"] = (0, _styles.withStyles)(styles, {
  name: 'DesignerFullScreenView'
})(DesignerFullScreenView);